import { render, staticRenderFns } from "./NewLookBanner.vue?vue&type=template&id=7008e012&scoped=true"
var script = {}
import style0 from "./NewLookBanner.vue?vue&type=style&index=0&id=7008e012&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008e012",
  null
  
)

export default component.exports